import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import * as applicantReducer from './applicant';
import * as authReducers from './auth';
import * as comboReducers from './combo';
import * as loadReducers from './loading';
import * as navigationReducers from './navigation';
import * as vacancyReducers from './vacancy';
import * as modalReducers from './modal';
import * as userReducers from './user';

export default combineReducers(Object.assign(
    applicantReducer,
    authReducers,
    comboReducers,
    loadReducers,
    navigationReducers,
    routerReducer,
    vacancyReducers,
    modalReducers,
    userReducers
));


// WEBPACK FOOTER //
// ./src/reducers/index.js